import { render, staticRenderFns } from "./ThreeLinkage.vue?vue&type=template&id=bd50bcca&scoped=true"
import script from "./ThreeLinkage.vue?vue&type=script&lang=js"
export * from "./ThreeLinkage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd50bcca",
  null
  
)

export default component.exports